<template>
  <div class="modal pretty-scrollbar">
    <div class="modal__content">
      <slot />
      <BaseIconButton
        v-if="hasCloseButton"
        icon="cross"
        class="modal__close"
        @click="$emit('close')"
      />
      <div v-if="$slots.actions" class="modal__actions">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseIconButton from '@/components/BaseIconButton.vue';

export default {
  name: 'BaseModal',
  components: {
    BaseIconButton,
  },
  props: {
    replic: {
      type: String,
      default: '',
    },
    hasCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.sayReplic();
  },
  methods: {
    sayReplic() {
      if (this.replic) {
        this.$robot.dialogService.setCase(this.replic, true, true);
        this.$robot.dialogService.sayReplicByName(this.replic, true);
      }
    },
  },
};
</script>

<style lang="stylus">
.modal
  display flex
  flex-flow row wrap
  justify-content center
  background alpha($c_text, 90%)
  overflow-y auto
  overflow-x hidden
  padding 1.25em
  color #fff

  &_confirm
    align-items center
    text-align center

  &__content
    position relative
    display block
    width 48em
    max-width 100%
    padding 2em
    background-color #fff
    color $c_text
    align-self flex-start
    animation fadeInBottom 500ms ease both
    ~/_confirm &
      width 34em
      align-self center
      padding-left 1em
      padding-right @padding-left
    ~/_clean &
      background none
      color #fff
      padding 0
    ~/_full &
      width 100%
      height 100%
      padding 0
    ~/_video &
      max-width 90%
      align-self center
      background none
      padding 0

  &__close
    abs top left 100%
    margin 0 0 0 1em
    color #fff

  &__title
    margin-bottom 1em

  &__actions
    margin-top 1em
    text-align center

  &__action.button
    margin-left 0.4em
    margin-right @margin-left
</style>
